module.exports = __webpack_public_path__ + "static/media/Food.a9437ce6.jpg";